var map = {
	"./app.js": 1769,
	"./corrections.js": 16649,
	"./demo.js": 75543,
	"./explorer.js": 83867,
	"./geolocalisation.js": 4861,
	"./metadata.js": 95577,
	"./news.js": 84982,
	"./observations.js": 50629,
	"./storymaps.js": 75892,
	"./user.js": 90847,
	"./viewer.js": 54202
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84870;